import { render, staticRenderFns } from "./installEdit.vue?vue&type=template&id=81564c16&scoped=true&"
import script from "./installEdit.vue?vue&type=script&lang=js&"
export * from "./installEdit.vue?vue&type=script&lang=js&"
import style0 from "./installEdit.vue?vue&type=style&index=0&id=81564c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81564c16",
  null
  
)

export default component.exports